import { CommonDataService } from 'src/sb-tools/typescript/services/common-data.service';
import { WindowRef } from 'src/sb-tools/typescript/services/window-ref.service';

import { Injectable } from '@angular/core';
import { HelperService } from '@sb-tools/typescript/services/helper.service';
import { AuthenticationService } from 'src/sb-tools/typescript/authentication/authentication.service';
import { SocialMediaService } from './social-media.service';
import { take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AppInitService {
    constructor(
        private commonDataService: CommonDataService,
        private windowRef: WindowRef,
        private authenticationService: AuthenticationService,
        private socialMediaService: SocialMediaService,
    ) {}

    initializeMyApp(): Promise<void> {
        return new Promise((resolve) => {
            this.commonDataService.community = this.authenticationService.community;
            this.commonDataService.communityName = this.authenticationService.community;

            const routeName = this.windowRef.nativeWindow.location.pathname.split('/')[2];
            this.commonDataService.isOneTime = routeName === 'onetime';
            this.commonDataService.isViewWithTicketList = routeName === 'tickets';

            if (this.commonDataService.isViewWithTicketList) {
                this.socialMediaService.get().pipe(take(1)).subscribe();
            }

            this.commonDataService.xToken = HelperService.getParameterByName('token', true);

            resolve();
        });
    }
}
